module.exports = __webpack_public_path__ + "assets/default_grey.c23127f5.png";